import { render, staticRenderFns } from "./warning_bar.vue?vue&type=template&id=27948746&scoped=true&"
import script from "./warning_bar.vue?vue&type=script&lang=js&"
export * from "./warning_bar.vue?vue&type=script&lang=js&"
import style0 from "./warning_bar.vue?vue&type=style&index=0&id=27948746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27948746",
  null
  
)

export default component.exports